import React from 'react'

const ProductGrowthIndexSubcategory: React.FC = () => (
  <svg width="70" height="71" viewBox="0 0 70 71" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="0.0769043" width="70" height="70" rx="14.5455" fill="url(#paint0_linear_4674_17936)" />
    <path
      d="M36.5885 37.6884C39.8456 34.4848 42.9958 31.3345 46.2529 28.1309C45.9859 28.1309 45.8257 28.0775 45.6122 28.0775C44.4375 28.0775 43.2628 28.0775 42.0881 28.0775C41.4474 28.0775 40.8067 27.9707 40.4329 27.33C39.899 26.3689 40.3261 24.8204 41.6076 24.7136C41.8746 24.7136 42.1415 24.6602 42.4619 24.6602C45.0782 24.6602 47.6945 24.6602 50.3108 24.6602C51.9127 24.6602 52.5 25.2476 52.5 26.9028C52.5 29.6259 52.5 32.4024 52.5 35.1255C52.5 35.873 52.1796 36.5138 51.4855 36.7807C50.8448 37.0477 50.1507 37.0477 49.6167 36.5671C49.0828 36.14 48.976 35.4993 48.976 34.8585C48.976 33.7373 48.976 32.616 48.976 31.4947C48.976 31.2811 48.976 31.1209 48.976 30.7472C48.6556 31.0142 48.4954 31.1209 48.3353 31.2811C44.918 34.5382 41.5542 37.902 38.1904 41.2124C37.87 41.5328 37.4428 41.7998 37.0157 41.96C36.3216 42.1735 35.7876 41.7998 35.3071 41.3192C33.5985 39.6106 31.8899 37.902 30.1812 36.1934C29.8075 35.8196 29.5939 35.8196 29.2735 36.1934C26.4436 39.0767 23.5604 41.9066 20.6771 44.7899C19.8762 45.5908 19.1286 45.6976 18.2743 45.1636C17.4734 44.6297 17.2598 43.6686 17.7938 42.8677C17.954 42.6007 18.1676 42.3871 18.3811 42.1735C21.6916 38.8631 24.9486 35.6061 28.259 32.2956C29.2735 31.2811 30.1812 31.2811 31.1957 32.2956C32.9043 33.9508 34.5596 35.6594 36.2682 37.3681C36.375 37.4748 36.5351 37.635 36.5885 37.6884Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4674_17936"
        x1="-1.56654e-06"
        y1="5.03845"
        x2="70"
        y2="67.0385"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E5A100" />
        <stop offset="1" stopColor="#F14B12" />
      </linearGradient>
    </defs>
  </svg>
)

export default ProductGrowthIndexSubcategory
